// extracted by mini-css-extract-plugin
export default {"numberInput":"number-input_numberInput__d-z5a","arrows":"number-input_arrows__zBVTq","arrowUp":"number-input_arrowUp__42-9B","arrowDown":"number-input_arrowDown__Nrtbl"};